import styled from "styled-components"
import { Box } from "@components/Layout"

const FilterContainer = styled(Box)`
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
`

export default FilterContainer
